export var PaymentServiceName;
(function (PaymentServiceName) {
    PaymentServiceName["stripe"] = "stripe";
    PaymentServiceName["xendit"] = "xendit";
    PaymentServiceName["paypal"] = "paypal";
    PaymentServiceName["paddle"] = "paddle";
})(PaymentServiceName || (PaymentServiceName = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CARD"] = "CARD";
})(PaymentMethodType || (PaymentMethodType = {}));
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["recurring"] = "recurring";
    SubscriptionType["onetime"] = "onetime";
})(SubscriptionType || (SubscriptionType = {}));
export var PriceType;
(function (PriceType) {
    PriceType["plan"] = "plan";
    PriceType["addon"] = "addon";
})(PriceType || (PriceType = {}));
